export type InvoiceStatus = 'draft' | 'activa' | 'cancelada'
export type CancellationStatus =
  | 'none'
  | 'pending_acceptance'
  | 'cancelled'
  | 'rejected'
  | 'expired'

export interface Invoice {
  id: number
  uuid: string | null
  folio: string | null
  series: string | null
  status: InvoiceStatus
  type: string | null
  total: string | number
  subtotal: string | number
  currency: string
  exchangeRate?: string | null
  discount?: string | null
  // Company invoices list shape
  rfcReceptor?: string | null
  legalNameReceptor?: string | null
  // Request invoice shape
  receiverRfc?: string | null
  receiverName?: string | null
  issuerRfc?: string | null
  issuerName?: string | null
  useCfdi: string | null
  paymentForm: string | null
  paymentMethod: string | null
  transactionId: string | null
  stampedAt: string | null
  cancelledAt: string | null
  cancellationStatus: CancellationStatus
  cancellationRequestedAt: string | null
  pendingCancellationAcceptance: boolean
  downloadable: boolean
  requestId?: number | null
  cefId?: number | null
  isReadyToStamp?: boolean
  facturapiId?: string | null
  facturapiStatus?: string | null
  pdfPath?: string | null
  issuedAt?: string | null
  notes?: string | null
}

export interface InvoiceStatusDisplay {
  label: string
  variant: 'green' | 'amber' | 'red' | 'gray'
}

export function getInvoiceStatusDisplay(inv: Invoice): InvoiceStatusDisplay {
  if (inv.cancellationStatus === 'pending_acceptance')
    return { label: 'Pend. aceptación receptor', variant: 'amber' }
  if (inv.cancellationStatus === 'rejected')
    return { label: 'Cancelación rechazada', variant: 'red' }
  if (inv.cancellationStatus === 'expired')
    return { label: 'Cancelación vencida', variant: 'gray' }
  if (inv.status === 'cancelada')
    return { label: 'Cancelada', variant: 'gray' }
  if (inv.status === 'activa')
    return { label: 'Emitida', variant: 'green' }
  return { label: 'Borrador', variant: 'amber' }
}
